export default function CalculatedValueIcon({ title, className }) {
  return (
    <span title={title}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        width="20px"
        height="20px"
        className={className}
        aria-hidden="true"
      >
        <path
          strokeWidth={1.5}
          d="M12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 0 0 2.25 2.25h10.5a2.25 2.25 0 0 0 2.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0 0 12 2.25Z"
        />
        <path
          strokeWidth={1}
          d="M8.25 6h7.5v2.25h-7.5V6ZM9.75 11.25v3M8.25 12.75h3M12.75 12.75h3M8.4 15.9l2.7 2.7M11.1 15.9l-2.7 2.7M12.75 17.25h3M14.25 15.9v.008M14.25 18.6v.008"
        />
      </svg>
    </span>
  )
}
